<template>
  <div>
    <UtteranceControl
      v-bind="$attrs"
      :isSelfEnter="true"
      :disabled-enter="disabled"
      :customEndter="true"
      v-on="$listeners"
      @disabledEnter="handelDisabledEnter"
      @enter="handelEnter"
    ></UtteranceControl>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UtteranceControl } from '@/components/resources';
import { namespace } from 'vuex-class';
import { Content } from '@forchange/storytime';
const cascaderModal = namespace('cascader');

@Component({
  components: {
    UtteranceControl
  }
})
export default class CascaderControl extends Vue {
  @Prop({ type: Object }) content: Content;
  @cascaderModal.State('selectArr') selectArr: Array<string>;
  @cascaderModal.State('otherValue') otherValue: Array<string>;
  @cascaderModal.State('isSubmit') isSubmit: Array<string>;
  @cascaderModal.State('durationStart') durationStart: number;
  @cascaderModal.State('maxLevel') maxLevel: number;
  get disabled() {
    return !this.isSubmit;
  }

  handelDisabledEnter() {
    this.$Message.warn({
      time: 1500,
      content: '请先完成选择再继续'
    });
  }

  handelEnter() {
    window.storyteller.updateAssignContent({
      $id: this.content.$id,
      $kind: this.content.$kind,
      ...{
        selectArr: this.selectArr,
        otherValue: this.otherValue,
        duration: this.durationStart ? new Date().getTime() - this.durationStart : 0,
        maxLevel: this.maxLevel
      }
    });
    this.$store.commit('cascader/clear');
    window.next();
    this.$emit('next');
  }
}
</script>
